import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FavoritesReportComponent } from '@ruby/shared/components/favorites-report/favorites-report.component';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';

@NgModule({
  declarations: [FavoritesReportComponent],
  imports: [
    CommonModule,
    MatListModule,
    ScrollingModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    PipesModule
  ],
  exports: [FavoritesReportComponent]
})
export class PureFavoritesReportModule {}
